module.exports = __webpack_public_path__ + "static/img/09.fec4468.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/09.png
// module id = A1wP
// module chunks = 1